<template>
    <div class="login-view">
        <div class="login-form-overflow">
            <div class="login-form">
                <lottie-animation path="lottie/error.json" style="width: 50%" />
                <div class="login-greeting">{{ $t('TOAST_ERROR_TITLE') }}</div>
                <div class="login-message">{{ $t('BAD_QR_PAGE_TITLE') }}</div>
                <div class="login-message">
                    {{ $t('BAD_QR_PAGE_SUBTITLE') }}
                </div>
                <div class="login-actions-row">
                    <div class="login-action" @click="goBack">
                        {{ $t('BUTTON_BACK') }}
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    data() {
        return {
            loading: false,
            playing: false,
            audio: ''
        }
    },
    methods: {
        goBack() {
            window.location = this.$env.getMainApp()
        }
    }
}
</script>
<style lang="scss" scoped>
.login-message {
    display: flex;
    align-items: center;
}
.login-message i {
    margin-top: 0.3rem;
    margin-left: 1rem;
    cursor: pointer;
    transition: $ease;
    font-size: 2rem;
    color: $action-accent;

    &:hover {
        transform: translateY(0.1rem);
    }
}
</style>
